<template>
  <UploadTemplate
    ref="form"
    :form="form"
    :rules="rules"
    :goodSamples="goodSamples"
    :badSamples="badSamples"
    sampleSize="w-20 h-22.5 md:w-34 md:h-38"
    :uploadInfoText="uploadInfoText"
    :pendingReason="pendingReason"
  />
</template>

<script>
import GoodPoaImage from '@/assets/images/register/img_poa_good.png';
import BlurryPoaImage from '@/assets/images/register/img_poa_blurry.png';
import EdgeMissingPoaImage from '@/assets/images/register/img_poa_edge_missing.png';
import ReflectivePoaImage from '@/assets/images/register/img_poa_reflective.png';
import UploadTemplate, { uploadFileValidator } from './templates/UploadTemplate.vue';

export default {
  components: { UploadTemplate },
  name: 'PoaUpload',
  props: {
    uploadInfoText: { type: String, default: '' },
    pendingReason: { type: String, default: '' }
  },
  data() {
    return {
      form: {
        frontImage: null,
        backImage: undefined // To hide input
      },
      rules: {
        frontImage: [{ required: true, validator: uploadFileValidator, trigger: 'change' }],
        backImage: [
          {
            required: false,
            validator: uploadFileValidator,
            trigger: 'change'
          }
        ]
      }
    };
  },
  computed: {
    frontImage() {
      const { frontImage } = this.form;
      return frontImage;
    },
    backImage() {
      const { backImage } = this.form;
      return backImage;
    }
  },
  watch: {
    frontImage() {
      this.autoFrontBackImage();
      this.validateField('frontImage');
    },
    backImage() {
      this.validateField('backImage');
    }
  },
  created() {
    this.goodSamples = [{ id: 1, label: 'verificationStatus.uploadTemplate.good', src: GoodPoaImage }];
    this.badSamples = [
      { id: 1, label: 'verificationStatus.uploadTemplate.blurry', src: BlurryPoaImage },
      { id: 2, label: 'verificationStatus.uploadTemplate.edgeMissing', src: EdgeMissingPoaImage },
      { id: 3, label: 'verificationStatus.uploadTemplate.reflective', src: ReflectivePoaImage }
    ];
  },
  methods: {
    autoFrontBackImage() {
      if (this.form.frontImage === null) {
        if (this.form.backImage !== null) {
          this.form.frontImage = this.form.backImage;
          this.form.backImage = null;
        } else {
          this.form.backImage = undefined;
        }
      } else {
        if (this.form.backImage === undefined) {
          this.form.backImage = null;
        }
      }
    },
    validateField(props, callback) {
      this.$refs.form?.validateField(props, callback);
    },
    validate(callback) {
      this.$refs.form?.validate((valid, rules) => {
        callback?.(valid, rules);
      });
    },
    clearValidate(props) {
      this.$refs.form?.clearValidate(props);
    }
  }
};
</script>
